import { IntlShape } from "react-intl"
import { createBreadcrumbsTranslated } from "../ContextualHeader"

export type InformationSubHeader = {
	title: string
	subTitle: string
}

export const createBreadcrumbs = (
	intl: IntlShape,
	informationSubHeader: InformationSubHeader,
	parentPath: string
) => {
	return createBreadcrumbsTranslated(intl, [
		{ id: informationSubHeader.title, path: parentPath },
		{ id: informationSubHeader.subTitle },
	])
}
